<div class="mb-3 cv-justify-space-between align-items-center">
  <h2>Summary</h2>
  <mat-icon [mat-dialog-close]="true" class="end">close</mat-icon>
</div>
<div class="summary-details-wrapper mt-2">
  <div class="d-grid grid-column p-2 gap20">
    <div class="justify-content-center">
      <div class="tile-title-eyebrow">Template Id</div>
      <div class="tile-title-tag">
        {{ data?.templateDetails?.templateId ? data?.templateDetails?.templateId : '--'}}
      </div>
    </div>
    <div class="d-flex">
      <div class="justify-content-center">
        <div class="tile-title-eyebrow">Template Name</div>
        <div class="tile-title-tag">
          {{ data?.templateDetails?.templateName ? data?.templateDetails?.templateName : '--'}}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="justify-content-center">
        <div class="tile-title-eyebrow">Tenant Name</div>
        <div class="tile-title-tag">
          {{ data?.templateDetails?.selectedTenant?.name ? (data?.templateDetails?.selectedTenant?.name |
          titlecase) : '--' }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="justify-content-center">
        <div class="tile-title-eyebrow">Description</div>
        <div class="tile-title-tag">
          {{ data?.templateDetails?.description ? data?.templateDetails?.description : '--' }}
        </div>
      </div>
    </div>
    <div class="d-flex">
      <div class="justify-content-center">
        <div class="tile-title-eyebrow">Payload Type</div>
        <div class="tile-title-tag">
          {{ data?.templateDetails?.payloadType ? (data?.templateDetails?.payloadType | uppercase) : '--' }}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="attribute-template-tables">
<app-common-table [tableData]="tableData" [columnHeader]="columnHeader" pageType="template-view">
</app-common-table>
</div>
<div class="the-button-set">
  <button mat-dialog-close>{{ data?.actionType ? 'Close' : 'Edit' }}</button>
  <button *ngIf="!data?.actionType" class="select" (click)="publish()">{{ data?.isEdit ? 'Update' : 'Publish'}}</button>
</div>